<template>
  <div class="sel-modal clearfix modal-container">
    <div class="sel-modal-header clearfix">
      <vxe-radio-group v-model="selectTab">
        <ul class="tab-list">
          <li v-if="type === 1">
            <vxe-radio name="xtabs" label="tab1">托运人合同</vxe-radio>
          </li>
          <li v-if="type === 2">
            <vxe-radio name="xtabs" label="tab1">承运人合同</vxe-radio>
          </li>
          <li v-if="type === 3">
            <vxe-radio name="xtabs" label="tab1">实际承运人合同</vxe-radio>
          </li>
        </ul>
      </vxe-radio-group>
      <div class="search-box">
        <vxe-input v-model="numb" style="height: 34px !important;border: 1px solid #dcdee2;" type="search"
                   placeholder="搜索" @keyup.enter.native="search"
                   @search-click="search"></vxe-input>
      </div>
    </div>
    <div>
      <vxe-table
          class="table-style"
          highlight-hover-row
          highlight-current-row
          show-footer
          show-overflow
          :auto-resize="true"
          max-height="545"
          stripe
          align="center"
          border="none"
          :loading="loading"
          :data="contractData"
          @current-change="currentChangeEvent"
      >
        <vxe-table-column field="numb" title="合同号" width="150">
          <template slot-scope="{ row }">
            <span @click.stop="showDetail(row.id,type)" style="color: #2D8CF0;cursor:pointer">{{ row.numb }}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column field="title" title="订单标题" width="120"></vxe-table-column>
        <vxe-table-column field="busType" title="业务类型" width="60">
          <template slot-scope="{ row }">
            <span>{{row.busType | contractbusMap}}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column field="addWay" title="签约方式" width="85">
          <template slot-scope="{ row }">
            <span>{{row.addWay | signType}}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column field="buyerName" title="购货方名称" width="200"></vxe-table-column>
        <vxe-table-column field="sellerName" title="承运人名称" width="200"></vxe-table-column>
        <vxe-table-column field="addTime" title="签约日期" width="140">
          <template slot-scope="{ row ,$rowIndex}">
            <span v-if="row.goodsList">{{ row.goodsList[0].addTime | timeFormatDate}}</span>
            <Icon
                type="ios-arrow-down"
                @click.stop="clickEvent3($rowIndex)"
                v-if="row.goodsList && row.goodsList.length > 1"
            />
            <vxe-pulldown :ref="$rowIndex" placement="bottom" transfer>
              <template v-slot:dropdown>
                <div class="my-dropdown3">
                  <vxe-table
                      auto-resize
                      style="width: 1095px;"
                      :data="row.goodsList"
                      stripe
                      show-overflow
                      align="center"
                      max-height="480"
                      :show-header="false"
                  >
                    <vxe-table-column field="addTime" title="签约日期" width="140">
                      <template slot-scope="{ row }">
                        <span>{{row.addTime | timeFormatDate}}</span>
                      </template>
                    </vxe-table-column>
                    <vxe-table-column field="goodsName" title="货名" width="105"></vxe-table-column>
                    <vxe-table-column field="unit" title="单位" width="60"></vxe-table-column>
                    <vxe-table-column field="counts" title="数量" width="75"></vxe-table-column>
                    <vxe-table-column field="price" title="单价" width="75"></vxe-table-column>
                    <vxe-table-column field="isTax" title="含税" width="60">
                      <template slot-scope="{ row }">
                        {{ row.isTax | taxMap }}
                      </template>
                    </vxe-table-column>
                    <vxe-table-column field="carShipNum" title="车船号" width="120"></vxe-table-column>
                    <vxe-table-column field="beginPlace" title="起运地" width="90"></vxe-table-column>
                    <vxe-table-column field="endPlace" title="到达地" width="90"></vxe-table-column>
                    <vxe-table-column field="beginTime" title="受载/起运时间" width="140">
                      <template slot-scope="{ row }">
                        <span>{{ row.beginTime | timeFormatDate }}</span>
                      </template>
                    </vxe-table-column>
                    <vxe-table-column field="endTime" title="到达时间" width="140">
                      <template slot-scope="{ row }">
                        <span>{{ row.endTime | timeFormatDate }}</span>
                      </template>
                    </vxe-table-column>
                  </vxe-table>
                </div>
              </template>
            </vxe-pulldown>
          </template>
        </vxe-table-column>
        <vxe-table-column field="goodsName" title="货名" width="105">
        </vxe-table-column>
        <vxe-table-column field="unit" title="单位" width="60"></vxe-table-column>
        <vxe-table-column field="counts" title="数量" width="75"></vxe-table-column>
        <vxe-table-column field="price" title="单价" width="75"></vxe-table-column>
        <vxe-table-column field="isTax" title="含税" width="60">
          <template slot-scope="{ row }">
            {{ row.isTax | taxMap }}
          </template>
        </vxe-table-column>
        <vxe-table-column field="carShipNum" title="车船号" width="120">
        </vxe-table-column>
        <vxe-table-column field="beginPlace" title="起运地" width="90"></vxe-table-column>
        <vxe-table-column field="endPlace" title="到达地" width="90"></vxe-table-column>
        <vxe-table-column field="beginTime" title="受载/起运时间" width="140">
          <template slot-scope="{ row }">
            <span>{{ row.beginTime | timeFormatDate }}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column field="endTime" title="到达时间" width="140">
          <template slot-scope="{ row }">
            <span>{{ row.endTime | timeFormatDate }}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column field="createUser" title="创建人" width="100"></vxe-table-column>
        <vxe-table-column field="createTime" title="创建日期" width="120">
          <template slot-scope="{ row }">
            <span style="color: #a7adad">{{ row.createTime | timeFormatDate }}</span>
          </template>
        </vxe-table-column>
      </vxe-table>
      <vxe-pager
          background
          size="small"
          :current-page.sync="page.currentPage"
          :page-size.sync="page.pageSize"
          :total="page.totalResult"
          @page-change="changePage"
      ></vxe-pager>
    </div>
    <vxe-modal v-model="detailVisible" title="查看合同详情" width="1300" height="600" @close="closeDetail" resize remember>
      <view-detail-modal ref="modalDetail" :editVisible="false"></view-detail-modal>
    </vxe-modal>
  </div>
</template>

<script>
  import $api from '@/apiProvider'
  import $C from "@/consts/index";
  import ViewDetailModal from "@/views/agreement/ViewDetailModal";
  import moment from "moment";

  export default {
    name: 'ChooseContract',
    components: {ViewDetailModal},
    data() {
      return {
        selectTab: 'tab1',
        loading: false,
        detailVisible: false,
        numb: null,
        type: '',
        contractData: [{}],
        page: {
          currentPage: 1,
          pageSize: 10,
          totalResult: 100
        },
        trackFlag: false,
        url: '',
        isCar: true,
      }
    },
    methods: {
      init(type) {
        this.numb = null;
        this.type = type;
        this.queryContractList(type)
      },
      async queryContractList(type) {
        this.loading = true;
        let res = await $api.agreement.request('queryContractListSelect', {
          type: type,
          numb: this.numb,
          orderBy: 2,
          page: this.page.currentPage,
          rows: this.page.pageSize,
        });
        if (res.status === 1) {
          this.page.totalResult = res.data.total;
          let contractData = res.data.rows;
          contractData.map(i => {
            if (i.goodsList) {
              i.goodsName = i.goodsList[0].goodsName;
              i.unit = i.goodsList[0].unit;
              i.counts = i.goodsList[0].counts;
              i.price = i.goodsList[0].price;
              i.isTax = i.goodsList[0].isTax;
              i.carShipNum = i.goodsList[0].carShipNum;
              i.beginPlace = i.goodsList[0].beginPlace;
              i.endPlace = i.goodsList[0].endPlace;
              i.beginTime = i.goodsList[0].beginTime;
              i.addTime = i.goodsList[0].addTime;
              i.endTime = i.goodsList[0].endTime;
              i.transportationType = i.goodsList[0].transportationType;
              i.packUnit = i.goodsList[0].packUnit;
              i.priceType = i.goodsList[0].priceType;
            }
          });
          this.contractData = contractData;
          this.loading = false;
        } else {
          this.$XModal.alert({
            message: res.message ? res.message : "接口异常",
            status: "error",
          });
        }
      },
      showDetail(id,type) {
        if (type == 1){
          if (!this.isHavePermission('buyer:queryContractDetail')){
            this.$Message["info"]({
              background: true,
              content: "对不起，您没有该权限！"
            });
            return ;
          }
        }
        else if(type == 2){
          if (!this.isHavePermission('seller:queryContractDetail')){
            this.$Message["info"]({
              background: true,
              content: "对不起，您没有该权限！"
            });
            return ;
          }
        }else if (type == 3){
          if (!this.isHavePermission('secondSeller:queryContractDetail')){
            this.$Message["info"]({
              background: true,
              content: "对不起，您没有该权限！"
            });
            return ;
          }
        }
        this.detailVisible = true;
        this.$refs.modalDetail.queryContractDetail(id);
      },
      changePage(e) {
        this.page.currentPage = e.currentPage;
        this.page.pageSize = e.pageSize;
        this.queryContractList(this.type);
      },
      clickEvent3(rowIndex) {
        this.$refs[rowIndex].togglePanel()
      },
      currentChangeEvent({row}) {
        this.$emit('choose', row)
      },
      search() {
        this.page.currentPage = 1
        this.queryContractList(this.type);
      },
      cancel() {
        this.numb = null;
      },
      close() {
        this.$refs.xTable.clearCurrentRow();
      },
      closeDetail() {
        this.$refs.modalDetail.close();
      }
    }
  }
</script>

<style scoped>
  .modal-container {
    position: relative;
    height: 100%
  }

  .btn-down {
    border: none;
  }

  .btn-down:focus {
    outline: none;
    border-color: transparent;
    box-shadow: none;
    background: transparent;
  }

  .btn-down.ivu-btn {
    background: transparent;
  }

  .btn-down.ivu-btn:hover {
    background: transparent;
  }
</style>